export default __webpack_public_path__ + "277eb3cb4efed6d2b1416549ea24d2f1.png";